import React from 'react';
import { Box, IconButton, Typography } from '@material-ui/core';
import { Close } from '@material-ui/icons';
import styles from './InstructionsStyles';

const InstructionItem = ({ instruction, setOpenNext }) => {
  if (!instruction) {
    return null;
  }

  const closeModalStyle = {
    container: {
      position: 'absolute',
      top: 24,
      right: 16,
    },
    closeIcon: {
      borderRadius: '6px',
      backgroundColor: 'black',
      color: 'white',
      fontWeight: 'bold',
      padding: 2,
    },
  };
  return (
    <div style={styles.instructionsWrapper}>
      <Box style={closeModalStyle.container}>
        <IconButton onClick={() => setOpenNext(false)} style={closeModalStyle.closeIcon}>
          <Close />
        </IconButton>
      </Box>
      <Typography variant="h4" style={styles.instructionTitle}>
        Инструкция №{instruction.id}
      </Typography>
      <div>{instruction.instruction}</div>
    </div>
  );
};
export default InstructionItem;
